import React from 'react'
import classes from './listingCard.module.scss'
import { IData } from './variables'
import PlusButton from '../SectionGallery/PlusButton'
import { motion } from 'framer-motion'

export type ListingCardProps = {
  data: false | IData
  filter?: string
}



const ListingCard: React.FC<ListingCardProps> = ({ data, filter }) => (
  <>
    {data && (data.category === filter || filter === '') && (
      <div>
        <motion.div
          variants={{
            visible: { opacity: 1, scale: 1, y: -40 },
            hidden: { opacity: 0, scale: 1, y: 40 },
          }}
          key={data.id}>
          <a href={`/${data.url}`} key={data.id} className={classes.columnItem} >
            <div className={classes.imageContainer}>
              <div className={classes.buttonContainer}>
                <div id="gallery-container">
                  <motion.div
                    variants={{
                      visible: { opacity: 1, scale: 1 },
                      hidden: { opacity: 0, scale: 0.75 },
                    }}
                  >
                    <PlusButton/>
                  </motion.div>
                </div>
              </div>
              <img src={data.image} alt=""/>
            </div>
          </a>
        </motion.div>
        <div className={classes.descriptionContainer}>
          <motion.div
            variants={{
              visible: { opacity: 1, scale: 1, y: -40 },
              hidden: { opacity: 0, scale: 1, y: 40 },
            }}
            key={data.id}>
            <p>
              {data.description}
            </p>
          </motion.div>
        </div>
        <div className={classes.brandNameContainer}>
          <motion.div
            variants={{
              visible: { opacity: 1, scale: 1, y: -40 },
              hidden: { opacity: 0, scale: 1, y: 40 },
            }}
            key={data.id}>
            <p className={classes.brandName}>{data.brand}</p>
          </motion.div>
        </div>
      </div>
    )}
  </>
)

export default ListingCard
